import AuthenticatedApp from './AuthenticatedApp';
import LogoutButton from './LogoutButton';
import CompleteProfileModal from './CompleteProfileModal';
import BudgetChoice from '../BudgetCreation/BudgetChoice';
import styles from './AppLoadingStates.module.css';

export function LoadingState() {
  return (
    <AuthenticatedApp>
      <div className={styles.loadingContainer}>
        <p>Loading your data...</p>
      </div>
    </AuthenticatedApp>
  );
}

export function ErrorState({ error }) {
  return (
    <AuthenticatedApp>
      <div className={styles.centeredContainer}>
        <h2 className={styles.errorHeading}>Error Loading User Data</h2>
        <p>{error}</p>
        <LogoutButton />
      </div>
    </AuthenticatedApp>
  );
}

export function ProfileCompletionState({ onComplete, getAccessTokenSilently }) {
  return (
    <AuthenticatedApp>
      <CompleteProfileModal
        onComplete={onComplete}
        getAccessTokenSilently={getAccessTokenSilently}
      />
    </AuthenticatedApp>
  );
}

export function BudgetSelectionState({ userEmail, onBudgetCreated, onInviteAccepted, getAccessTokenSilently }) {
  return (
    <AuthenticatedApp>
      <BudgetChoice
        userEmail={userEmail}
        onBudgetCreated={onBudgetCreated}
        onInviteAccepted={onInviteAccepted}
        getAccessTokenSilently={getAccessTokenSilently}
      />
    </AuthenticatedApp>
  );
}
